import Api from 'api';

import {
  CLEAR_SUBCOMPANY,
  DELETE_SUBCOMPANY,
  GET_SUBCOMPANIES,
  GET_SUBCOMPANY,
  MODIFY_SUBCOMPANY,
  SAVE_SUBCOMPANY,
  TOGGLE_SUBCOMPANY,
  RESET_SUBCOMPANIES,
} from 'subcompanies/constants';

export const getSubcompanies = (companyId) => (dispatch) => {
  return dispatch({
    type: GET_SUBCOMPANIES,
    meta: { needAuth: true },
    payload: Api.subcompanies.getSubcompanies(companyId),
  });
};

export const getSubcompany = (companyId, subcompanyId) => (dispatch) =>
  dispatch({
    type: GET_SUBCOMPANY,
    meta: { needAuth: true, companyId, subcompanyId },
    payload: Api.subcompanies.get(companyId, subcompanyId),
  });

export const toggleSubcompany = (companyId, subcompanyId) => (dispatch) =>
  dispatch({
    type: TOGGLE_SUBCOMPANY,
    meta: { needAuth: true, companyId, subcompanyId },
    payload: Api.subcompanies.toggle(companyId, subcompanyId),
  });

export const deleteSubcompany = (companyId, subcompanyId) => (dispatch) =>
  dispatch({
    type: DELETE_SUBCOMPANY,
    meta: { needAuth: true, companyId, subcompanyId },
    payload: Api.subcompanies.delete(companyId, subcompanyId),
  });

export const modifySubcompany = (payload) => ({
  type: MODIFY_SUBCOMPANY,
  payload,
});

export const saveSubcompany = (companyId, data) => ({
  type: SAVE_SUBCOMPANY,
  meta: { needAuth: true, companyId, subcompanyId: data.id },
  payload: data.id
    ? Api.subcompanies.edit(companyId, data.id, data)
    : Api.subcompanies.add(companyId, data),
});

export const clearSubcompany = () => ({
  type: CLEAR_SUBCOMPANY,
});

export const resetSubcompanies = () => ({
  type: RESET_SUBCOMPANIES,
});



// WEBPACK FOOTER //
// src/modules/secured/modules/subcompanies/actions/subcompanies_actions.js